import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { REACT_APP_IMG } from 'cfgCommon/config'
import { NOTIFICATION_EVENT_REASON } from './redux/constants'
import './CallNotificationItem.less'

const CALL_ENTRY_TITLE_SUFFIX = ' te intentó llamar'

export const CALL_TYPE = {
  OUTBOUND_ANSWERED: 'outbound_answered',
  OUTBOUND_MISSED: 'outbound_missed',
  INBOUND_MISSED: 'inbound_missed',
}

export const formatCallDateTime = timestamp =>
  moment(timestamp).format('DD/MM/YYYY, HH:mm')

export const getCallContactName = title => {
  if (!title) return ''
  if (title.endsWith(CALL_ENTRY_TITLE_SUFFIX)) {
    return title.slice(0, -CALL_ENTRY_TITLE_SUFFIX.length).trim()
  }
  return title
}

export const getCallType = notification => {
  const { eventReason, message } = notification || {}

  if (eventReason === NOTIFICATION_EVENT_REASON.CALL_EXIT) {
    return String(message || '').toLowerCase().includes('answered')
      ? CALL_TYPE.OUTBOUND_ANSWERED
      : CALL_TYPE.OUTBOUND_MISSED
  }

  return CALL_TYPE.INBOUND_MISSED
}

const CallDirectionArrow = ({ callType }) => {
  if (callType === CALL_TYPE.OUTBOUND_ANSWERED) {
    return (
      <svg
        className="call-notification-arrow call-notification-arrow--outbound-answered"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6 10.5V1.5M6 1.5L2.5 5M6 1.5L9.5 5"
          stroke="#2C872C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (callType === CALL_TYPE.OUTBOUND_MISSED) {
    return (
      <svg
        className="call-notification-arrow call-notification-arrow--outbound-missed"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6 10.5V1.5M6 1.5L2.5 5M6 1.5L9.5 5"
          stroke="#D32F2F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  return (
    <svg
      className="call-notification-arrow call-notification-arrow--inbound-missed"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6 1.5V10.5M6 10.5L2.5 7M6 10.5L9.5 7"
        stroke="#D32F2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

CallDirectionArrow.propTypes = {
  callType: PropTypes.oneOf(Object.values(CALL_TYPE)).isRequired,
}

const CallNotificationItem = ({ notification, onMarkAsRead, closeMenu }) => {
  const history = useHistory()
  const callType = getCallType(notification)
  const contactName = getCallContactName(notification.title)
  const isMissed = callType !== CALL_TYPE.OUTBOUND_ANSWERED

  const handleClick = () => {
    if (notification.redirectUrl) {
      history.push(notification.redirectUrl)
      closeMenu()
    }
    if (!notification.read && onMarkAsRead) {
      onMarkAsRead(notification.id)
    }
  }

  const formatNotificationImage = () => {
    let imageUrl
    try {
      imageUrl = new URL(notification?.icon)
    } catch (error) {
      imageUrl = `${REACT_APP_IMG}/${notification.icon}`
    }
    return imageUrl
  }

  const nameClasses = [
    'call-notification-name',
    isMissed ? 'call-notification-name--missed' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className="call-notification-item" onClick={handleClick}>
      <div className="call-notification-icon">
        {notification.icon && (
          <img
            src={formatNotificationImage()}
            alt="Icono de WhatsApp"
            className="call-notification-thumbnail"
          />
        )}
      </div>
      <div className="call-notification-content">
        <div className={nameClasses}>{contactName}</div>
        <div className="call-notification-meta">
          <CallDirectionArrow callType={callType} />
          <span>{formatCallDateTime(notification.time)}</span>
        </div>
      </div>
    </div>
  )
}

CallNotificationItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    time: PropTypes.string.isRequired,
    read: PropTypes.bool,
    redirectUrl: PropTypes.string,
    eventReason: PropTypes.string,
  }).isRequired,
  onMarkAsRead: PropTypes.func,
  closeMenu: PropTypes.func.isRequired,
}

export default CallNotificationItem
